
const __default__ = {
  props:{ 
    disabled: {type: Boolean, default: false},
    
    tiny: {type: Boolean, default: false},
    small: {type: Boolean, default: false},
    
    primary: {type: Boolean, default: false},
    text: {type: Boolean, default: false},
    link: {type: Boolean, default: false},
    flat: {type: Boolean, default: false},
    gap: {type: String, default: undefined},
  
    loading: {type: Boolean, default: false},
    hover: {type: Boolean, default: false},
  },
  computed: {
    el_type() {
      if (this.primary) return 'primary'
      return 'default'
    },
    c_disabled(){
      if (this.disabled) return true
      return this.loading
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "42d7ec62-gap": (_ctx.gap)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__